import dynaForms from '@elab/core/utils/dynaForms';
import { SHARED_ACTIONS } from '@elab/core/utils/constants';

const getTypes = ({ storeName, parentStoreName }) => ({
    ...dynaForms.getTypes(storeName),
    parent: {
        ...dynaForms.getTypes(parentStoreName),
        CHECK_PIN_CODE: `${parentStoreName}.${SHARED_ACTIONS.checkPinCode}`,
        SHOW_PINCODE: `${parentStoreName}.SHOW_PINCODE`,
        SET_PIN_CODE_STATUS: `${parentStoreName}.${SHARED_ACTIONS.setPinCodeStatus}`,
    },
});

export default getTypes;
